var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-content",style:({'backgroundImage': _vm.indexBgUrl?`url(${_vm.$base.url + _vm.indexBgUrl})`:''})},[_c('div',{staticClass:"home-title animate__animated",attrs:{"id":"home-title"}},[_c('div',{staticClass:"titles"},[_c('span',[_vm._v("欢迎使用")]),_vm._v(" "+_vm._s(this.$project.projectName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }